import { MantineThemeProvider } from '@cowbell/ui';

import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import { QueryParamsProvider } from '../components/providers/QueryParamsProvider';
import store, { persistor } from '../config/storeConfig';
import GrowthBookProvider from './GrowthBookProvider';

import QueryClientProvider from './QueryClientProvider';
import SnackbarProvider from './SnackbarProvider';
import ThemeProvider from './ThemeProvider';

import CSVDownloadSubWrapper from './CSVDownloadSubWrapper';

import AskMooProvider from '../components/ask-moo/context/AskMooProvider';
import { AnalyticsInitializer } from '../config/analytics/AnalyticsInitializer';
import { AnalyticsProvider } from '../config/analytics/AnalyticsProvider';
import type { WithChildrenProps } from '../types/components/common';
import I18nextProvider from './I18nextProvider';
import { CmailModalProvider } from '../components/icons/CmailModalContext';
import { StaffAvatarManifestProvider } from '../components/user-avatar/StaffAvatarManifest';

function GlobalProviders({ children }: WithChildrenProps) {
  return (
    <QueryClientProvider>
      <ReduxProvider store={store as any}>
        <PersistGate persistor={persistor}>
          <GrowthBookProvider>
            <BrowserRouter>
              <AnalyticsProvider>
                <AnalyticsInitializer />
                <AskMooProvider>
                  <I18nextProvider>
                    <ThemeProvider>
                      <MantineThemeProvider>
                        <SnackbarProvider>
                          <QueryParamsProvider>
                            {/* Above every tree that shows a staff avatar: the routes, v2 modals
                                (RouteResolver's ConsoleDialogs) and the cmail modal, which
                                CmailModalProvider renders beside its children. */}
                            <StaffAvatarManifestProvider>
                              <CmailModalProvider>
                                <CSVDownloadSubWrapper>
                                  {children}
                                </CSVDownloadSubWrapper>
                              </CmailModalProvider>
                            </StaffAvatarManifestProvider>
                          </QueryParamsProvider>
                        </SnackbarProvider>
                      </MantineThemeProvider>
                    </ThemeProvider>
                  </I18nextProvider>
                </AskMooProvider>
              </AnalyticsProvider>
            </BrowserRouter>
          </GrowthBookProvider>
        </PersistGate>
      </ReduxProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default GlobalProviders;
